import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleCheckGuard } from './guards/role-check-guard';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import {RouterUriComponents} from './enums/router-uri-components.enum';
import { LoggedInUserResolver } from './resolvers/logged-in-user-resolver';
import { XpoAuthenticationGuard } from '@xpo/ngx-auth';

export const RouterDefinitions: Routes = [
  {
    path: RouterUriComponents.CUSTOMER_RULE,
    loadChildren: () => import('./components/customer-rule/customer-rule.module').then(m => m.CustomerRuleModule),
    canActivate: [ XpoAuthenticationGuard, RoleCheckGuard ],
    resolve:  { transaction: LoggedInUserResolver }
  },
  {
    path: RouterUriComponents.SEARCH_PAGE,
    loadChildren: () => import('./components/customer-search/customer-search-routing.module').then(m => m.CustomerSearchRoutingModule),
    canActivate: [ XpoAuthenticationGuard, RoleCheckGuard ],
    resolve:  { transaction: LoggedInUserResolver }
  },

  {
    path: RouterUriComponents.NOT_AUTHORIZED_PAGE,
    component: NotAuthorizedComponent
  },
  {
    path: '**',
    redirectTo: RouterUriComponents.SEARCH_PAGE,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(RouterDefinitions)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    RoleCheckGuard
  ],
  declarations: []
})
export class AppRoutingModule { }
